<template>
    <!-- 大运流年组件:查看 -->
    <div class="layout-comment-list">
        <div class="layout-clr-item" v-for="dayunData of dayunLiunianList" v-bind:key="dayunData.name" v-bind:id="dayunData.name">
            <!-- 大运信息 -->
            <div class="layout-clr-dayun-info" v-if="dayunData && dayunData.edited">
                <div class="layout-clr-title-box">
                    <span class="layout-clr-title" @click.stop="clickDayunTitle(dayunData)"><span class="layout-clr-title-title">{{dayunData.ganzhi}}{{dayunData.typeBefore ? '' : '大运'}}</span>{{dayunData.year}}-{{dayunData.year+dayunData.liunian.length-1}}</span>
                </div>
                <div class="layout-clr-content" v-if="dayunData.typeChoosed > 0 && !dayunData.typeBefore">
                    <span class="layout-clr-label">前五年运势：</span>
                    <span v-if="fromMyComment">
                        <span v-for="dtype1 of dayunData.type" v-bind:key="'before-half-5' + dtype1 + Math.random(0, 10)">          
                            <span v-if="dtype1.choosed" class="layout-clr-item cur">{{dtype1.text}}，</span>
                        </span>
                    </span>
                    <span v-else>
                        <span class="layout-clr-item cur" v-for="dtype1 of dayunData.type" v-bind:key="'before-half-5' + dtype1 + Math.random(0, 10)">{{dtype1}}，</span>
                    </span>
                </div>
                <div class="layout-clr-content" v-if="dayunData.type2Choosed > 0 && !dayunData.typeBefore">
                    <span class="layout-clr-label">后五年运势：</span>
                    <span v-if="fromMyComment">
                        <span v-for="dtype2 of dayunData.type2" v-bind:key="'later-half-5' + dtype2 + Math.random(0, 10)">
                            <span v-if="dtype2.choosed" class="layout-clr-item cur">{{dtype2.text}}，</span>
                        </span>
                    </span>
                    <span v-else>
                        <span class="layout-clr-item cur" v-for="dtype2 of dayunData.type2" v-bind:key="'later-half-5' + dtype2 + Math.random(0, 10)">{{dtype2}}，</span>
                    </span>
                </div>
                <comment-content-read
                    v-if="dayunData.content != ''"
                    v-bind:className="'layout-clr-paragraph'"
                    v-bind:textId="dayunData.name"
                    v-bind:textValue="dayunData.content">
                </comment-content-read>
            </div>
            <!-- 流年 -->
            <div class="layout-clr-liunian-list" v-for="liunianData of dayunData.liunian" v-bind:key="liunianData.year" v-bind:id="liunianData.name">
                <div class="layout-clr-liunian-item" v-if="liunianData && liunianData.edited">
                    <div class="layout-clrln-title">
                        <span @click.stop="clickLiunianTitle(dayunData, liunianData)">
                            <span class="layout-clrln-title-title">{{liunianData.year}}</span>{{liunianData.ganzhi}}流年
                        </span>
                    </div>
                    <div class="layout-clrln-content" v-if="liunianData.typeChoosed > 0">
                        <span class="layout-clr-label">上半年运势：</span>
                        <span v-if="fromMyComment">
                            <span v-for="ltype1 of liunianData.type" v-bind:key="'before-half-year' + ltype1 + Math.random(0, 10)">
                                <span v-if="ltype1.choosed">{{ltype1.text}}，</span>
                            </span>
                        </span>
                        <span v-else>
                            <span v-for="ltype1 of liunianData.type" v-bind:key="'before-half-year' + ltype1 + Math.random(0, 10)">{{ltype1}}，</span>
                        </span>
                    </div>
                    <div class="layout-clrln-content" v-if="liunianData.type2Choosed > 0">
                        <span class="layout-clr-label">下半年运势：</span>
                        <span v-if="fromMyComment">
                            <span v-for="ltype2 of liunianData.type2" v-bind:key="'later-half-year' + ltype2 + Math.random(0, 10)">
                                <span v-if="ltype2.choosed" class="layout-clr-item cur">{{ltype2.text}}，</span>
                            </span>
                        </span>
                        <span v-else>
                            <span v-for="ltype2 of liunianData.type2" v-bind:key="'later-half-year' + ltype2 + Math.random(0, 10)">{{ltype2}}，</span>
                        </span>
                    </div>
                    <comment-content-read
                        v-if="liunianData.content != ''"
                        v-bind:className="'layout-clrln-paragraph'"
                        v-bind:textId="liunianData.name"
                        v-bind:textValue="liunianData.content">
                    </comment-content-read>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommentContentRead from './CommentContentRead.vue'
export default {
    name: 'CommentEmbeddedListRead',
    components: { CommentContentRead },
    computed: {
        dayunLiunianList() {
            return this.$store.state.comment.dayunLiunianList;
        },
        fromMyComment() {
            return this.$store.state.comment.fromMyComment;
        }
    },
    methods: {
        clickDayunTitle(dayunData) {
            this.$store.dispatch('minifatefortune/triggerFortuneItemClick', dayunData.name);
        },
        clickLiunianTitle(dayunData, liunianData) {
            var me = this;
            me.$store.dispatch('minifatefortune/triggerFortuneItemClick', dayunData.name);
            setTimeout(() => {
                me.$store.dispatch('minifatefortune/triggerFortuneItemClick', liunianData.name);
            }, 10);
        }
    }
}
</script>
